import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { CustomBreakpoints } from '../../../../../themes/default/index';

export const useStyles = makeStyles(({
  breakpoints,
  palette,
  fontSizes,
  fontWeights,
}: Theme) => ({
  root: {
    position: 'relative',
    height: 'fit-content',
    paddingTop: '1.5rem',
    borderRadius: '0.5rem',
    overflow: 'hidden',
    background: 'linear-gradient(286.95deg, #ffe7e9 1.2%, #e6f6ff 66.28%)',
    width: '100%',
    [breakpoints.up('md')]: {
      width: 'calc((100% - 1.5rem) / 2)',
    },
    [breakpoints.up('xl')]: {
      padding: '1.5rem 0 0 1.5rem',
    },
    '& .MuiTabs-root': {
      width: '100%',
      minHeight: 'unset',
      margin: '0 auto',
      padding: 2,
      borderRadius: '2rem',
      background: palette.common.white,
    },
    '& .MuiTab-fullWidth': {
      minHeight: 'unset',
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      borderRadius: '2.25rem',
      color: palette.text.primary,
      fontSize: fontSizes.sm,
      fontWeight: fontWeights.regular,
      lineHeight: 1,
      textTransform: 'none',
      opacity: 1,
      '&.Mui-selected': {
        background: palette.primary.dark,
        color: palette.common.white,
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  tabsWrapper: {
    padding: '0 1rem 1.5rem',
    [breakpoints.up('xl')]: {
      padding: '0 1.5rem 1.5rem 0',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    width: '100%',
    minHeight: '17.5rem',
    borderRadius: '0.375rem',
    flexBasis: '45%',
  },
  topRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
    alignItems: 'flex-start',
    [breakpoints.up('xl')]: {
      flexDirection: 'column',
    },
  },
  linksColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    flex: 1,
    [breakpoints.up('xl')]: {
      flex: 'unset',
    },
  },
  panelInner: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4.5%',
    [breakpoints.up(CustomBreakpoints.bannerMobileUp)]: {
      gap: '35%',
    },
    [breakpoints.up('md')]: {
      gap: '5.5%',
    },
    [breakpoints.up('lg')]: {
      gap: '10%',
    },
  },
  qrCode: {
    width: '8.75rem',
    height: '8.75rem',
    padding: '0.375rem',
    borderRadius: '0.5rem',
    lineHeight: 0,
    background: palette.common.white,
    '& img': {
      width: '100%',
    },
    [breakpoints.down(375)]: {
      width: '5.75rem',
      height: '5.75rem',
    },
  },
  link: {
    display: 'flex',
    width: 'fit-content',
    height: 'min-content',
    '& img': {
      width: '8.75rem',
      height: 'auto',
    },
  },
  text: {
    fontSize: fontSizes.xs,
    lineHeight: 1.4,
  },
 
  bannerContainer: {
    display: 'flex',
    marginBottom: '4%',
    overflow: 'hidden',
    width: '100%',
    aspectRatio: '16 / 9',
    flexBasis:'55%',
  },

  imageBanner: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'left center',
  },

  topRowBanner: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    alignItems: 'flex-start',
    padding: '0 1rem 0.75rem',
  },
}));
